import React, { Component } from 'react';
import {truncate} from 'utils/truncate.js';
import Colors from 'components/Colors.js';
let colors = 0;
const COLORS = new Colors();
const UPDATE_RATE = 100;

const TAGS = new Set(['hi-hat', 'kick', 'snare', 'clap', 'crash', 'ride', 'breaks', 'tom']);

class GroupThumbnailPart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            height: 0
        };
    }

    get thumbnail() {
        let sample = this.props.track.sample;
        if (sample === undefined) {
            return undefined;
        }
        return sample.getThumbnail();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.height !== nextState.height) {
            return true;
        }

        if (this.props.selectedTrack !== nextProps.selectedTrack) {
            return true;
        }

        if (this.props.renders !== nextProps.renders) {
            return true;
        }

        if (this.props.track !== nextProps.track) {
            return true;
        }

        return false;
    }
    
    componentDidMount() {
        this.timer = setInterval(() => {
            this.setState({
                height: Math.min(60 + this.props.track.trackMeter.getLevel(), 100)});
        }, UPDATE_RATE);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    onDragOver(e) {
        e.preventDefault();
    }

    onDragStart(e) {
        this.props.onDraggingTrack(this.props.track);
    }

    onDrop(e, tags) {
        if (this.props.trackDragging !== undefined &&
           this.props.trackDragging.group !== this.props.group) {
            this.props.groups.addToGroup(this.props.trackDragging, this.props.group);
            this.props.onGroupsChanged();
        }
    }

    getNameToShow() {
        if (this.props.track.sample !== undefined) {
            let tag = this.props.track.sample.tags.filter(x => TAGS.has(x))[0];
            if (tag) {
                return tag;
            }
        }

        return truncate(this.props.track.getName());
    }

    render() {
        let style = {
            //width: this.props.partWidth,
            height: this.state.height,
        }

        let thumbnailStyle = {
            height: 100,
            opacity: 1,
        }

        let thumbnailPartStyle = {};
        let color = undefined;
        if ( this.thumbnail === undefined || this.thumbnail === '') {
            let stringToConvert = this.props.track.sample && this.props.track.sample.getId() !== undefined ? 
                this.props.track.sample.getId() :
                this.props.track.getName();
            color = COLORS.getColorForHash(stringToConvert);
            thumbnailPartStyle.backgroundColor = color;
        }
        
        let unselected =
            this.props.selectedTrack !== undefined &&
            this.props.selectedTrack !== this.props.track.trackNumber;

        if (unselected && this.props.isSelectedGroup) {
            thumbnailPartStyle.opacity = 0.5;
        }

        let isTrackSelected =
            this.props.selectedTrack === this.props.track.trackNumber;
        
        let coloredThumbnailStyle = style;
        coloredThumbnailStyle['background-color'] = rainbow(colors+=5);

        let nameStyle = {
        };
        if (color) {
            nameStyle['backgroundColor'] = COLORS.brighten(color, 1.2);
        }

        let name = this.getNameToShow();
        if (this.props.numParts === 3) {
            name = name.slice(0, 2);
        } else if (this.props.numParts > 3) {
            name = name.slice(0, 1);
        }

        return (
            <div
              onDragStart={(e) => this.onDragStart(e)}
              onDragOver={(e) => this.onDragOver(e)}
              onDrop={(e)=>{this.onDrop(e)}}                   
              draggable
              style={thumbnailPartStyle}
             className={isTrackSelected ? 'thumbnail-part-container selected-track' : unselected ? "thumbnail-part-container" : "thumbnail-part-container selected"}
              onClick={() => this.props.onClickTrack(this.props.track)}
              >
            <div
              style={coloredThumbnailStyle}
              className={unselected ? "blank-thumbnail thumbnail-part unselected" : "blank-thumbnail thumbnail-part"}>
              {this.thumbnail !== undefined ? 
                <img 
                      onError={() => this.setState({thumbnail: undefined})}
                  src={this.thumbnail}
                  className={unselected ? "draggable droppable thumbnail-part unselected" : "draggable droppable thumbnail-part"}/>
                  : ''} 
            </div>
            {this.thumbnail === undefined ? 
                <div style={nameStyle} className="group-part-name">{name}</div>
            : ''}
          </div>);
    }
}

function rainbow(n) {
    n = n * 240 / 512;
    return 'hsl(' + n + ',100%,50%)';
}

export default GroupThumbnailPart;
